import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import servicesData from "../services.json";
import contentConfig from "../content.config.json";
import "../Styles/Services.css";

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const service = Object.values(servicesData)
    .flat()
    .find((service) => service.slug === slug);

  if (!service) {
    return (
      <div className="page-shell">
        <section className="page-hero">
          <div className="page-hero-inner">
            <h1 className="page-hero-title">Service not found</h1>
          </div>
        </section>
        <div className="service-detail-wrapper">
          <button className="back-button" onClick={() => navigate("/services")}>
            <FaArrowLeft /> {contentConfig.services.back}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-shell">
      <section className="page-hero">
        <div className="page-hero-inner">
          <span className="section-badge">Service</span>
          <h1 className="page-hero-title">{service.name}</h1>
        </div>
      </section>

      <div className="service-detail-wrapper">
        {service.details.map((detail, index) => (
          <div key={index} className="service-detail-section">
            <h2>{detail.header}</h2>
            <p>{detail.info}</p>
          </div>
        ))}

        <button className="back-button" onClick={() => navigate("/services")}>
          <FaArrowLeft /> {contentConfig.services.back}
        </button>
      </div>
    </div>
  );
};

export default ServiceDetail;
